// extracted by mini-css-extract-plugin
module.exports = {"root":"Shelf_root__L9vWx","header":"Shelf_header__Zyt6M","heading":"Shelf_heading__Ewqzj","seeAll":"Shelf_seeAll__F8YJ7","scroller":"Shelf_scroller__KpJyf"};